import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NewContentLocker } from 'src/app/models/pubModel/contentlocker.model';
import { LockerService } from '../../../../shared/services/pubServices/lockers.service';
import { Options, LabelType } from 'ngx-slider-v2';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pub-lockernew-component',
  templateUrl: './content-new.html',
  styleUrls: ['./content-new.scss']
})

export class contentNewComponent implements OnInit {
  templateEditorStep: string = 'offers'
  contentLocker = new NewContentLocker();
  noOffers: any;
  oldh2Text: any;
  errorMessage = '';
  range = (start, end) => Array.from({length: (end - start)}, (v, k) => k + start);
  sliderLeadsValue: number = 1;
  sliderValue: number;
  active = 'general';
  
  // Custom class slider
  custSlideroptions: Options = {
    floor: 10,
    ceil: 100,
    step: 10,
    showTicks: true,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return '<b>leads of all offers:</b> ' + value +'%';
        default:
          return value + '%';
      }
    }
  };

  constructor(private toastrService: ToastrService, private router: Router, private lockerService: LockerService) {}

  ngOnInit() {
    this.noOffers = this.range(1, 3+1);
    this.oldh2Text = "Please complete one of offer below to unlock:";

    this.contentLocker = {
      /**
       * General
       */
        lockerName: ''
      , lockerLeadsInPercent: 10
      , isLockerLeadsOn: false  //1-yes 2-no
      , contentLockerUnlockType: 1  //1-Close 2-Redirect 3-JavaScript Eval 3-Close
      , lockerUnlocklink: ''
      /**
        * Overlay
        */
       , overlayColor: '#000000'
       , overlayOpacity: 0.2

      /**
           * Main frame
           */
       , mainFrameFont: 'Arial'
       , mainFrameWidth: 780
       , mainFrameMinHeight: 360
       , mainFrameBackgroundColor: '#F7F7F7'
       , mainFrameBorderSize: 1
       , mainFrameBorderColor: '#F7F7F7'
       /**
        * Header
        */
      , h1Text: 'This premium content is locked.'
      , h1TextAlign: 'center'
      , h1Width: 100
      , h1MarginTop: 60
      , h1FontColor: '#9c9c9c'
      , h1FontSize: 24
      , h1FontWeight: 800
       /**
        * Subheader
        */
      , h2Text: 'Please complete one of offer below to unlock:'
      , h2TextAlign: 'center'
      , h2Width: 100
      , h2MarginTop: 5
      , h2FontColor: '#E97436'
      , h2FontSize: 16
      , h2FontWeight: 400
       /**
        * Offers table
        */
      , offersNumbers: 3
      , offersTableWidth: 90
      , offersTableMargin: 15
      , offersTablePadding: 0
      , offersTableBorderSize: 1
      , offersTableBorderColor: '#d5d5d5'
      , offerLineHeight: 20
      , offerLinePadding: 0
      , offerTextAlign: 'center'
      , offerLinkDecoration: 'none'
      , offerLinkColor: '#E97436'
      , offerLinkHoverColor: '#000000'
      , offerLinkFontSize: 14
      , offerEvenBackgroundColor: '#E97436'
      , offerEvenBackgroundColorOpacity: 0.4

       /**
        * Notice properties
        */
      , noticeText: 'Use valid information only when completing a survey.'
      , noticeTextAlign: 'center'
      , noticeWidth: 100
      , noticeMarginTop: 5
      , noticeFontColor: '#9C9C9C'
      , noticeFontSize: 12
      , noticeFontWeight: 400

       /**
        * Waiting properties
        */
      , waitingText1: 'Your download will be unlocked upon valid participation in the offer of your choice.'
      , waitingText2: 'Do you want to try unlock content with other offer?'
      , waitingTextAlign: 'center'
      , waitingWidth: 100
      , waitingMarginTop: 140
      , waitingLinkText: 'Click here.'
      , waitingFontColor: '#000000'
      , waitingFontSize: 14
      , waitingFontWeight: 400

      };
  }

  offerChange(){
    this.noOffers = this.range(1, this.contentLocker.offersNumbers! + 1);

    // if(this.contentLocker.lockerLeads>this.contentLocker.offersNumbers)
    //   this.contentLocker.lockerLeads=this.contentLocker.offersNumbers;
  }

  getOfferBackground(i) {
    if (i % 2 === 0) {
      return this.hexToRgbAOffer(this.contentLocker.offerEvenBackgroundColor) //this.editForm.value.offerNthBackground
    } else {
      return ''
    }
  }

  hexToRgbAOffer(hex){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+ this.contentLocker.offerEvenBackgroundColorOpacity +')';
    }
    throw new Error('Bad Hex');
    }

  hexToRgbA(hex){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+ this.contentLocker.overlayOpacity +')';
    }
    throw new Error('Bad Hex');
    }

  public tabChange(changeEvent: NgbNavChangeEvent) {
      switch (changeEvent.nextId)
        {
          case "General":
            this.templateEditorStep='offers';
            break;

          case "Overlay":
            this.templateEditorStep='offers';
            break;

          case "Mainframe":
            this.templateEditorStep='offers';
            break;

          case "Header":
            this.templateEditorStep='offers';
            break;

          case "Subheader":
            this.templateEditorStep='offers';
            break;

          case "Offers":
            this.templateEditorStep='offers';
            break;

          case "Notice":
            this.templateEditorStep='offers';
            break;

          case "Waiting":
            this.templateEditorStep='waiting';
            break;
        }
    }

  onSave(){
    this.contentLocker.contentLockerUnlockType = Number( this.contentLocker.contentLockerUnlockType);

    if(this.contentLocker.lockerName!='')
    {
      this.lockerService.newContentLocker(this.contentLocker).subscribe(
        response => {
          // zwraca aplikacja API
          if(response.error)
          {
            this.errorMessage = response.error.errors[0].message;
            this.toastrService.error(`${this.errorMessage}`, 'Error !');
          }
          else
          {
            this.toastrService.success('New content locker created.', 'Success !');
            this.router.navigate(['/pub/gateways']);
          }
      },
      err => {
          // zwraca serwer HTML
          this.errorMessage =  err.status + ` - ` + err.statusText;
          this.toastrService.error(`${this.errorMessage}`, 'Error !');
      });
    }
    else
    {
      this.toastrService.error('Content locker name is needed', 'Error !');
    }
  }

  onCancel(){
    this.router.navigate(['/pub/gateways']);
  }

  onChangeLeads(){
    if(this.contentLocker.isLockerLeadsOn == true)//1-yes 2-no
    {
      this.sliderLeadsValue = Math.floor((this.contentLocker.lockerLeadsInPercent! * this.contentLocker.offersNumbers!)/100);
      if(this.sliderLeadsValue < 1)
        this.sliderLeadsValue = 1;

      this.contentLocker.h2Text="Please complete " + this.sliderLeadsValue + " of offer below to unlock:";
    }
  }

  onChangeVisible(){
    //1-yes activated leads
    //2-no leads is deactivated
    if(this.contentLocker.isLockerLeadsOn == true)
      this.contentLocker.h2Text = "Please complete " + this.sliderLeadsValue + " of offer below to unlock:";
    if(this.contentLocker.isLockerLeadsOn == false)
    this.contentLocker.h2Text = "Please complete one of offer below to unlock";
  }

  onChangeh2Text(){
    this.oldh2Text = this.contentLocker.h2Text;
  }
}
